function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { visitExit, visitSkip, Nodes } from "./Nodes";
export var Documents;
(function (_Documents) {
  function isImageDoctype(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "image";
  }
  _Documents.isImageDoctype = isImageDoctype;
  function isElementDoctype(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "element";
  }
  _Documents.isElementDoctype = isElementDoctype;
  function isPageDoctype(type) {
    return !!type && type.toLowerCase().startsWith("page/");
  }
  _Documents.isPageDoctype = isPageDoctype;
  function isPageTurnDoctype(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "page/turn";
  }
  _Documents.isPageTurnDoctype = isPageTurnDoctype;
  function isPageConcatDoctype(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "page/concat";
  }
  _Documents.isPageConcatDoctype = isPageConcatDoctype;
  function isPageLayoutsDoctype(type) {
    return isPageTurnDoctype(type) || isPageConcatDoctype(type);
  }
  _Documents.isPageLayoutsDoctype = isPageLayoutsDoctype;
  function isPageLayoutDoctype(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "page/layout";
  }
  _Documents.isPageLayoutDoctype = isPageLayoutDoctype;
  function isBackgroundDocType(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "background";
  }
  _Documents.isBackgroundDocType = isBackgroundDocType;
  function isMaterialDocType(type) {
    return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "material";
  }
  _Documents.isMaterialDocType = isMaterialDocType;
  function isDocument(value) {
    return "type" in value && value.schema === "SIG";
  }
  _Documents.isDocument = isDocument;
  function isImageDocument(value) {
    return isImageDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isImageDocument = isImageDocument;
  function isElementDocument(value) {
    return isElementDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isElementDocument = isElementDocument;
  function isPageLayoutDocument(value) {
    return isPageLayoutDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isPageLayoutDocument = isPageLayoutDocument;
  function isPageTurnDocument(value) {
    return isPageTurnDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isPageTurnDocument = isPageTurnDocument;
  function isPageConcatDocument(value) {
    return isPageConcatDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isPageConcatDocument = isPageConcatDocument;
  function isPageLayoutsDocument(value) {
    return isPageLayoutsDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isPageLayoutsDocument = isPageLayoutsDocument;
  function isPageDocument(value) {
    return isPageDoctype(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isPageDocument = isPageDocument;
  function isBackgroundDocument(value) {
    return isBackgroundDocType(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isBackgroundDocument = isBackgroundDocument;
  function isMaternalDocument(value) {
    return isMaterialDocType(value === null || value === void 0 ? void 0 : value.type);
  }
  _Documents.isMaternalDocument = isMaternalDocument;
  function visit(source, visitor) {
    var nodeVisitor = {
      element: visitor.element
    };
    function visitLayout(layout) {
      var _visitor$background;
      (_visitor$background = visitor.background) === null || _visitor$background === void 0 || _visitor$background.call(visitor, layout.background);
      if (layout.elements) {
        Documents.visitElement(layout.elements, nodeVisitor);
      }
    }
    if (Documents.isDocument(source)) {
      if (Documents.isPageDocument(source)) {
        if (Documents.isPageLayoutDocument(source)) {
          visitLayout(source);
        } else {
          var _visitor$background2;
          (_visitor$background2 = visitor.background) === null || _visitor$background2 === void 0 || _visitor$background2.call(visitor, source.background);
          var _iterator = _createForOfIteratorHelper(source.layouts),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var layout = _step.value;
              visitLayout(layout);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      } else if (Documents.isImageDocument(source)) {
        visitLayout(source);
      } else if (isElementDocument(source)) {
        return Documents.visitElement([source.element], nodeVisitor);
      } else if (isMaternalDocument(source)) {
        return Documents.visitElement(source.elements, nodeVisitor);
      }
    } else {
      return visitLayout(source);
    }
  }
  _Documents.visit = visit;
  function visitElement(source, visitor) {
    if (Array.isArray(source)) {
      return Nodes.visit(source, visitor);
    } else if (isDocument(source)) {
      if (isPageDocument(source)) {
        function visitLayout(layout) {
          return Nodes.visit(layout.elements, visitor);
        }
        if (isPageLayoutDocument(source)) {
          visitLayout(source);
        } else {
          var _iterator2 = _createForOfIteratorHelper(source.layouts),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var layout = _step2.value;
              var symbol = visitLayout(layout);
              if (symbol === visitSkip || symbol === visitExit) {
                return symbol;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } else if (isImageDocument(source)) {
        return Nodes.visit(source.elements, visitor);
      } else if (isElementDocument(source)) {
        return Nodes.visit([source.element], visitor);
      } else if (isMaternalDocument(source)) {
        return Nodes.visit(source.elements, visitor);
      }
    } else {
      return Nodes.visit(source.elements, visitor);
    }
  }
  _Documents.visitElement = visitElement;
  function resolveTextCodePoints(document) {
    var set = new Set();
    function append(text) {
      var points = text.split("");
      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        set.add(point);
      }
    }
    visitElement(document, {
      element: {
        enter: function enter(element) {
          var as = element.as,
            properties = element.properties;
          switch (as) {
            case "Text":
              {
                append(properties.text);
                break;
              }
            case "EffectText":
              {
                append(properties.text);
                break;
              }
          }
        }
      }
    });
    var codePoints = Array.from(set);
    codePoints.sort();
    return codePoints;
  }
  _Documents.resolveTextCodePoints = resolveTextCodePoints;
  function resolveElements(document, predicate) {
    var elements = [];
    visitElement(document, {
      element: {
        enter: function enter(element) {
          if (predicate(element)) {
            elements.push(element);
          }
        }
      }
    });
    return elements;
  }
  _Documents.resolveElements = resolveElements;
  function visitTextElement(source, visit) {
    visitElement(source, {
      element: {
        enter: function enter(element) {
          var as = element.as;
          switch (as) {
            case "Text":
              {
                visit(element);
                break;
              }
            case "EffectText":
              {
                visit(element);
                break;
              }
          }
        }
      }
    });
  }
  _Documents.visitTextElement = visitTextElement;
  function resolveFontFaceSets(source) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$resolveText = options.resolveText,
      resolveText = _options$resolveText === void 0 ? function (value) {
        return value;
      } : _options$resolveText;
    var familyCodepointMap = {};
    function append(family, text) {
      if (!family) {
        return;
      }
      var set = familyCodepointMap[family] || (familyCodepointMap[family] = new Set());
      var _iterator3 = _createForOfIteratorHelper(text),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var codePoint = _step3.value;
          set.add(codePoint);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    var _iterator4 = _createForOfIteratorHelper(source),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        visitTextElement(item, function (element) {
          var as = element.as,
            properties = element.properties;
          var style = properties.style;
          var text = resolveText(properties.text);
          switch (as) {
            case "Text":
              {
                append(style.fontFamily, text);
                break;
              }
            case "EffectText":
              {
                append(style.fontFamily, text);
                break;
              }
          }
        });
      }

      //空格也是有字形的
      // const ignoreRegex = /\s/g;
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var fontFaces = [];
    for (var family in familyCodepointMap) {
      var codePoints = Array.from(familyCodepointMap[family]);
      if (codePoints.length > 0) {
        codePoints.sort();
        fontFaces.push({
          family: family,
          codePoints: codePoints
        });
      }
    }
    return fontFaces;
  }
  _Documents.resolveFontFaceSets = resolveFontFaceSets;
})(Documents || (Documents = {}));